import type { FC, TextareaHTMLAttributes } from "react";

import { Text } from "../Text";

interface FormTextareaProps extends Omit<
  TextareaHTMLAttributes<HTMLTextAreaElement>,
  "size"
> {
  label?: string;
  error?: string;
}

/**
 * Shared form textarea component with consistent styling
 * Matches TaskActivityFilters reference tokens
 */
export const FormTextarea: FC<FormTextareaProps> = ({
  label,
  error,
  className = "",
  ...textareaProps
}) => (
  <div>
    {label && (
      <Text
        variant="caption"
        as="label"
        className="mb-1 block font-mono text-[10px] font-bold uppercase tracking-widest text-slate-500 dark:text-slate-400"
      >
        {label}
      </Text>
    )}
    <textarea
      {...textareaProps}
      className={`w-full rounded-none border border-slate-300 bg-white px-3 py-2 font-mono text-xs text-slate-900 transition-colors focus:border-emerald-500 focus:outline-none focus:ring-1 focus:ring-emerald-500 dark:border-slate-700 dark:bg-arti-background dark:text-slate-100 ${className}`}
    />
    {error && (
      <p className="mt-1 font-mono text-[10px] font-bold text-rose-600 dark:text-rose-400">
        {error}
      </p>
    )}
  </div>
);
